
class HXFormField {
    /** @private */
    inputObj = null;
    /** @private */
    inputName = null;
    /** @private */
    formVars = {};
    /** @private */
    formName = null;

    /** @private */
    validationMsg = null;
    /** @private */
    validationPassed = true;

    /**
     * @param {string} inputName
     * @param {string} formName
     */
    constructor(inputName,formName) {
        this.inputName = inputName;
        this.formName = formName;

        if (this.formName==null) this.formName = HXForm.HXFORM_NAME_DEFAULT;
        if (document.forms[this.formName]===undefined) {
            this.formName = null;
        } else {
            this.formVars = new HXForm(this.formName).getFormVars();
        }

        if (this.constructor.name === "HXFormFieldMarkerCheckbox"){
            //Sonderfall: Marker: Element ist ein Div mit id = inputName
            this.inputObj = document.getElementById(this.inputName);
        }else{
            // Ansonsten immer gleich:
            var obj = null;
            if (this.formName!==null && document.forms[this.formName]!==undefined) {
                obj = document.forms[this.formName].elements[this.inputName]; //absichtlich kein JQuery -> getAttribute
            }
            if (obj===undefined || obj===null) { //z.B. HXFormFieldSignatur ist kein echtes Inputfeld
                obj = document.getElementsByName(this.inputName)[0];  //absichtlich kein JQuery -> getAttribute
            }
            this.inputObj = obj;

        }

        // pruefen, ob das DOM-Element zum JS-Objekt passt:
        if (this.fieldExists()){
            let attr = $(this.getFieldObj()).attr("data-hx-hxformfield");
            if (attr!==this.constructor.name){
                console.log("Wrong Formfield-Object: " + attr + " != new " + this.constructor.name + "('" + inputName + "')");
                this.inputObj = null;
            }
        }
    }

    /**
     * @returns {object|null}
     */
    getFieldObj() {
        if (this.inputObj !== null && this.inputObj !== undefined && typeof (this.inputObj) === 'object'){
            return this.inputObj;
        }else{
            return null;
        }
    }

    /**
     * Check if the correct InputField exists and is accessible
     * @returns {boolean}
     */
    fieldExists() {
        // Check, if the inputObj is set
        return (this.inputObj !== null && this.inputObj !== undefined && typeof (this.inputObj) === 'object');
    }

    /**
     * @protected
     */
    _validateFieldInit() {
        this.validationMsg = null;
        this.validationPassed = true;
    }

    /**
     * Gibt Feldvalidierungsergebnis als alert() Meldung aus
     * @param {boolean} setFocus
     * @param {object|null} inputObjOther Input Objekt fuer Focus, falls dieses abweichet (z.B. Time-Feld von DateTime-Feld
     * @protected
     */
    _validateFieldAlert(setFocus=true,inputObjOther=null) {
        if (this.validationPassed===false) {
            window.alert(this.validationMsg);
            var inputObj = this.inputObj;
            if (inputObjOther!=null) inputObj = inputObjOther;

            try {if (setFocus === true) {
                inputObj.focus();
                inputObj.select();
            }} catch (e) {}
        }
    }

    /**
     * @returns {boolean}
     */
    getEditable() {
        //getAttribute returns null if Data-Attrib does not exist
        //setAttribute can handly dynamically added data-attributes
        return this.inputObj.getAttribute('data-hx-editable') === 'true';
    }

    /**
     * @returns {string}
     */
    getFormFieldTypeName() {
        return this.inputObj.getAttribute('data-hx-hxformfield');
    }

    /**
     * @returns {boolean}
     */
    getOptional() {
        return this.inputObj.getAttribute('data-hx-optional') === 'true';
    }

    /**
     * Fuer Standardfelder - sonst individuell implementiert
     * @param {boolean} optional
     * @param {string} fieldtype
     */
    setOptional(optional,fieldtype) {
        var ft = 'text'; var ft2 = 'text';
        if (fieldtype==='select') ft = 'select';
        if (fieldtype==='textarea') ft = 'textarea';
        if (fieldtype==='signature') ft = 'signature';
        if (fieldtype==='reference') ft = 'reference';
        if (fieldtype==='textareahtml') ft = 'textareahtml';
        if (fieldtype==='datetime') {ft = 'text';ft2 ='datetime';}
        if (fieldtype==='marker') {ft = 'marker';}
        if (fieldtype==='uploadbig') {ft = 'uploadbig';}
        if (fieldtype==='dropdown') {ft = 'dropdown';}
        if (fieldtype==='formfieldpopup') {ft = 'formfieldpopup';}
        if (fieldtype==='formfieldtable') {ft = 'formfieldtable';}

        if (optional===true) {
            this.inputObj.setAttribute("data-hx-optional", true);

            //Styles nur im Edit-Modus anpassen
            if (this.getEditable()===true) {
                if (ft === "signature") {
                    if (document.getElementById('js_hxformfield_signature_btnbar_' + this.inputName)) document.getElementById('js_hxformfield_signature_btnbar_' + this.inputName).classList.remove("hxformfield_signature_notnull");
                } else if (ft === "textareahtml") {
                    document.querySelectorAll("." + this.inputName + "Container .jqte")[0].classList.remove("notnull");
                    document.querySelectorAll("." + this.inputName + "Container .jqte")[0].classList.add("null");
                } else if (ft === "reference") {
                    this.inputObj.classList.remove("formreferencenotnull");
                    this.inputObj.classList.add("formreference")
                } else if (ft === "marker") {
                    document.getElementById(this.inputName).classList.remove("notnull");
                } else if (ft === "uploadbig") {
                    this.inputObj.classList.remove("not-null");
                } else if (ft === "dropdown") {
                    $(this.inputObj).removeClass('formselectnotnull');
                    $(this.inputObj).addClass('formselect')
                } else if (ft === "formfieldtable") {
                    //ignorieren
                } else if (ft === "formfieldpopup") {
                    $('.js-' + this.inputName + '-field').each((index, element) => {
                        $(element).removeClass('formtextnotnull').addClass('formtext');
                    });
                } else {
                    this.inputObj.className = "form" + ft;
                    this.inputObj.setAttribute("onfocus", "this.className='form" + ft + "focus'");
                    this.inputObj.setAttribute("onblur", "this.className='form" + ft + "'");

                    if (ft2 === "datetime") {
                        this.inputObjTime.className = "form" + ft;
                        this.inputObjTime.setAttribute("onfocus", "this.className='form" + ft + "focus'");
                        this.inputObjTime.setAttribute("onblur", "this.className='form" + ft + "'");
                    }
                }
            }

        } else if (optional===false) {
            this.inputObj.setAttribute("data-hx-optional",false);

            //Styles nur im Edit-Modus anpassen
            if (this.getEditable()===true) {
                if (ft === "signature") {
                    if (document.getElementById('js_hxformfield_signature_btnbar_' + this.inputName)) document.getElementById('js_hxformfield_signature_btnbar_' + this.inputName).classList.add("hxformfield_signature_notnull");
                } else if (ft === "textareahtml") {
                    document.querySelectorAll("." + this.inputName + "Container .jqte")[0].classList.remove("null");
                    document.querySelectorAll("." + this.inputName + "Container .jqte")[0].classList.add("notnull");
                } else if (ft === "reference") {
                    this.inputObj.classList.remove("formreference");
                    this.inputObj.classList.add("formreferencenotnull");
                } else if (ft === "marker") {
                    document.getElementById(this.inputName).classList.add("notnull");
                } else if (ft === "uploadbig") {
                    this.inputObj.classList.add("not-null");
                } else if (ft === "dropdown") {
                    $(this.inputObj).removeClass('formselect');
                    $(this.inputObj).addClass('formselectnotnull');
                } else if (ft === "formfieldtable") {
                    //ignorieren
                } else if (ft === "formfieldpopup") {
                    $('.js-' + this.inputName + '-field').each((index, element) => {
                        $(element).removeClass('formtext').addClass('formtextnotnull');
                    });
                } else {
                    this.inputObj.className = "form" + ft + "notnull";
                    this.inputObj.setAttribute("onfocus", "this.className='form" + ft + "notnullfocus'");
                    this.inputObj.setAttribute("onblur", "this.className='form" + ft + "notnull'");

                    if (ft2 === "datetime") {
                        this.inputObjTime.className = "form" + ft + "notnull";
                        this.inputObjTime.setAttribute("onfocus", "this.className='form" + ft + "notnullfocus'");
                        this.inputObjTime.setAttribute("onblur", "this.className='form" + ft + "notnull'");
                    }
                }
            }
        }
    }

    /**
     * Returns the current input-value of the field
     * @returns {string}
     */
    getValue() {
        //Hinweis: .value beinhaltet den aktuellen Wert im Feld, getAttribute('value') den urspruenglichen Wert
        return this.inputObj.value;
    }

    /**
     * Fuer Standardfelder mit value Attribue - sonst individuell implementiert
     * @param {string|int} value
     */
    setValue(value) {
        this.inputObj.value = value; //funktioniert bei input und select
    }


    /**
     * Returns the original value of the field
     * @returns {string}
     */
    getValueOld() {
        return this.inputObj.getAttribute('data-hx-value-old');
    }


    /**
     * @returns {string}
     */
    getLabel() {
        return hx.replace(this.inputObj.getAttribute('data-hx-label'), "-<br>", "");
    }

    /**
     * Returns the errormessage produced by the last validateInput() call
     * @returns {string}
     */
    getValidationMsg() {
        return this.validationMsg;
    }

    /**
     * Returns the validationPassed state produced by the last validateInput() call
     * @returns {string}
     */
    getValidationPassed() {
        return this.validationPassed;
    }

}